import { Media } from "./media";

export interface StaffTeamSeason {
    id: number;
    staff_id: number;
    staff_name: string;
    team_id: number;
    team_name: string;
    season_id: number;
    season_name: string;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyStaffTeamSeason: StaffTeamSeason = {
    id: 0,
    staff_id: 0,
    staff_name: '',
    team_id: 0,
    team_name: '',
    season_id: 0,
    season_name: '',
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}

export interface Staff {
    id: number;
    user_id: number;
    name: string;
    email: string;
    first_name: string;
    last_name: string;
    birthdate: string;
    phone: string;
    document_id: string;
    description: string;
    avatar: Media[];
    birth_city: string;
    birth_region: string;
    birth_country: string;
    city: string;
    region: string;
    country: string;
    address: string;
    registered_in: StaffTeamSeason[];
    role: string;
    status: number;
    created_by: number;
    created_at: string;
    changed_by: number;
    changed_at: string;
}

export const emptyStaff: Staff = {
    id: 0,
    user_id: 0,
    name: '',
    email: '',
    first_name: '',
    last_name: '',
    birthdate: '',
    phone: '',
    document_id: '',
    description: '',
    avatar: [],
    birth_city: '',
    birth_region: '',
    birth_country: '',
    city: '',
    region: '',
    country: '',
    address: '',
    registered_in: [],
    role: '',
    status: 0,
    created_by: 0,
    created_at: '',
    changed_by: 0,
    changed_at: ''
}
